// import { useChainStore } from "../shared/store"
export const decideChainAction = async (chainsAction) => {
    // const chainId = chainsAction.chainId ?? useChainStore.getState().chainId
    // switch (process.env.BRAND_ID) {
    //   case "levana": {
    //     const { isInjectiveChainId } = await import("../injective/chain")
    //     if (isInjectiveChainId(chainId)) {
    //       return chainsAction.injective
    //     } else {
    //       return chainsAction.cosmos
    //     }
    //   }
    //   case "rujira":
    //   }
    return chainsAction.rujira;
};
export const allChainsCallAction = (chainsAction) => {
    const { chainId, ...actions } = chainsAction;
    const { rujira, ...levana } = actions;
    switch (process.env.BRAND_ID) {
        case "levana":
            return Promise.all(Object.values(levana).map((action) => action()));
        case "rujira":
            return rujira();
    }
};
//# sourceMappingURL=chain.js.map